import type { Components, Theme } from "@mui/material/styles";

export const MuiCardHeader: Components<Theme>["MuiCardHeader"] = {
  defaultProps: {
    slotProps: {
      title: {
        variant: "h2",
      },
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(3, 3, 2),
    }),
  },
};
